module.exports = __webpack_public_path__ + "static/media/Episode_Hero_Desktop_1.058e7fde.png";